import { useSiteContent } from "@/lib/siteContent";

export default function FinalCTA({ children }) {
  const sc = useSiteContent();
  return (
    <section
      id="register"
      data-testid="final-cta-section"
      className="relative py-28 lg:py-36 text-white overflow-hidden"
      style={{ background: "linear-gradient(135deg, #050B5C 0%, #0A0A0A 55%, #1A2DD7 140%)" }}
    >
      <div className="absolute inset-0 dot-bg opacity-[0.06] pointer-events-none" />
      <div
        className="absolute -top-40 -right-40 w-[640px] h-[640px] rounded-full pointer-events-none blur-3xl opacity-30"
        style={{ background: "radial-gradient(circle, #1A2DD7 0%, transparent 60%)" }}
      />
      <div
        className="absolute -bottom-32 -left-32 w-[520px] h-[520px] rounded-full pointer-events-none blur-3xl opacity-20"
        style={{ background: "radial-gradient(circle, #7C8AFF 0%, transparent 60%)" }}
      />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full mb-8 border backdrop-blur-md"
            style={{ background: "rgba(255,255,255,0.08)", borderColor: "rgba(255,255,255,0.22)" }}
          >
            <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#7C8AFF", boxShadow: "0 0 12px #7C8AFF" }} />
            <span
              className="text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.22em] text-white/95"
            >
              Complete your registration
            </span>
          </div>

          <h2
            className="font-black uppercase leading-[0.94] tracking-[-0.025em]"
            style={{
              fontSize: "clamp(40px, 6.5vw, 92px)",
              fontFamily: "'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif",
            }}
          >
            Your idea deserves{" "}
            <span
              style={{
                color: "#7C8AFF",
                textShadow: "0 0 40px rgba(124,138,255,0.5)",
              }}
            >
              movement.
            </span>
          </h2>

          <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-2xl mx-auto leading-[1.6]">
            You don&apos;t need another month, another quote, another developer, or another perfect moment.
          </p>
          <p className="mt-3 text-lg sm:text-xl text-white max-w-2xl mx-auto leading-[1.6]">
            In <strong>{sc.lab_duration_label}</strong>, you can learn what&apos;s possible, start building smarter, and walk away with a skill you can keep using.
          </p>

          <div className="mt-8 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm text-white/70">
            <span className="inline-flex items-center gap-1.5">
              <span className="w-1 h-1 rounded-full bg-white/50" />
              <strong className="text-white font-bold">{sc.lab_date_primary_label}</strong>
            </span>
            <span className="text-white/40">·</span>
            <span>{sc.lab_date_primary_time}</span>
            <span className="text-white/40">·</span>
            <span className="font-bold text-white">{sc.lab_price_label}</span>
            <span className="text-white/40">·</span>
            <span>Klarna &amp; Afterpay</span>
          </div>
        </div>

        <div className="mt-14">{children}</div>
      </div>
    </section>
  );
}
